import * as React from 'react';

interface PagerProps {
    page: number,
    pageSize: number,
    totalRecords: number,
    pageChanged(page: number): void;
}

interface PagerDetails {
    page: number
}

export default class Pager extends React.Component<PagerProps, PagerDetails> {
    constructor(props: PagerProps) {
        super(props);
        this.state = {
            page: 1
        };

    }

    pageChanged = (page: number) => {
        this.props.pageChanged(page);
    }

    firstPage = () => {
        this.setState({ page: 1 })
        this.pageChanged(1);
    }

    prevPage = () => {
        var currentPage = this.props.page;
        var newPage;
        if (currentPage == 1) {
            newPage = 1;
            this.setState({ page: 1 });
        } else {
            newPage = currentPage - 1;
            this.setState({ page: currentPage - 1 });
        }
        this.pageChanged(newPage);
    }

    nextPage = () => {
        this.setState({ page: this.props.page + 1 });
        this.pageChanged(this.props.page + 1);
    }

    lastPage = () => {
        var totalPages = (this.props.totalRecords / this.props.pageSize) | 0;
        this.setState({ page: totalPages + 1 });
        this.pageChanged(totalPages + 1);
    }

    render() {
        var buttonFirst = "<<";
        var buttonPrev = "<";
        var buttonNext = ">";
        var buttonLast = ">>";

        var totalPages = Math.ceil(this.props.totalRecords / this.props.pageSize);

        return (

            <div className="pagingrow">
                <div className="pagingButtons">
                    <button className={ this.props.page == 1 ? "hidden" : "pagingbutton" } onClick={this.firstPage} type="button">{buttonFirst}</button>
                    <button className={this.props.page == 1 ? "hidden" : "pagingbutton"} onClick={this.prevPage} type="button">{buttonPrev}</button>
                </div>
                <div className="pagingText">
                    <span className="pagingbutton--note">Page {this.props.page} of {totalPages}</span>
                </div>
                <div className="pagingButtons">
                    <button className={this.props.page == totalPages ? "hidden" : "pagingbutton"} onClick={this.nextPage} type="button">{buttonNext}</button>
                    <button className={this.props.page == totalPages ? "hidden" : "pagingbutton"} onClick={this.lastPage} type="button">{buttonLast}</button>
                </div>
            </div>
        )
    }

}
